import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ScrollableGrid = styled(Grid)({
  maxHeight: "300px",
  overflow: "auto",
});
